export default {
  allSeverityLevels: 'Alle Schweregrade',
  zeroSeverityLevels: '0 Schweregrade sind ausgewählt',
  severityLevels: 'Schweregrade',
};
